// @flow

import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormattedRelative } from '@catalytic/catalytic-ui';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  timestamp: {
    ...theme.typography.extraSmallText,
    minHeight: '1.125rem',
    textAlign: 'right',
    color: theme.colors.battleshipGrey
  },
  button: {
    borderLeft: `1px solid ${theme.colors.battleshipGrey}`,
    marginLeft: '0.625rem',
    paddingLeft: '0.625rem'
  }
}));

type Props = {
  isEmbedded: boolean,
  sessionStorageKey: string,
  updatedAt?: string
};

export const WebformLastEdited = ({
  isEmbedded,
  sessionStorageKey,
  updatedAt
}: Props) => {
  const intl = useIntl();
  const classes = useStyles();
  const confirmMessage = intl.formatMessage({
    id: 'process.last.saved.discardChanges.confirmation',
    defaultMessage:
      'Are you sure you want to discard your changes to this form? This cannot be undone.'
  });

  const handleDiscardChangesClick = React.useCallback(() => {
    const confirmDiscard = window.confirm(confirmMessage);
    if (confirmDiscard) {
      window.localStorage.removeItem(sessionStorageKey);
      window.location.reload();
    }
  }, [confirmMessage, sessionStorageKey]);

  return (
    <div className={classes.timestamp} data-testid="webform-timestamp">
      {!isEmbedded && updatedAt && typeof updatedAt === 'string' && (
        <>
          <FormattedMessage
            id="process.last.saved.message"
            defaultMessage="Last edit was {date}"
            values={{
              date: <FormattedRelative polling value={updatedAt} />
            }}
          />
          <button
            className={classes.button}
            onClick={handleDiscardChangesClick}
          >
            <FormattedMessage
              id="process.last.saved.discardChanges"
              defaultMessage="Discard Changes"
            />
          </button>
        </>
      )}
    </div>
  );
};
WebformLastEdited.displayName = 'WebformLastEdited';

export default WebformLastEdited;
